export default __webpack_public_path__ + "static/media/4.ed5657e9.png";